module.exports = __webpack_public_path__ + "assets/img/2209.409fdd3a.svg";